module.exports = __webpack_public_path__ + "img/usericon.e0945969.png";